
import { connect } from 'react-redux';
import LyricsPane from '../components/LyricsPane';

const mapStateToProps = (state) => ({
    music: state.aovivoBar.NowPlaying.musicLive,
    breakpoint: state.breakpointReducer,
});


// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
const LyricsPaneContainer = connect(mapStateToProps, {})(LyricsPane);

export default LyricsPaneContainer;

